module.exports = __webpack_public_path__ + "img/Confirm.238884b5.svg";